<template>
  <common-cell-renderer-actions
    :actions="filtered"
    @delete="confirmDeleteRecord()">
  </common-cell-renderer-actions>
</template>

<script>
import commonSingleCellRendererActions from '@/views/modules/_mixins/commonSingleCellRendererActions';
import CommonCellRendererActions from '@/views/modules/_components/cell-renderer/CommonCellRendererActions.vue';

/**
 * Cell renderer actions to Inbounds SMS
 *
 * @module views/modules/inbound-sms/InboundSMSListCellRendererActions
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */
export default {
  name: 'InboundSMSListCellRendererActions',
  components: {
    CommonCellRendererActions,
  },
  mixins: [commonSingleCellRendererActions],
  computed: {
    filtered() {
      return this.filteredActionsFromParent;
    },
  },
};
</script>
